import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';
import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';
import PartsColor from '@/components/partsColor/PartsColor';
import { parseEnum } from '@/utils';


@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})
export default class Bloom1 extends Vue {
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;



  product: ProductDefinition;



  defHideObjects = [
    'bloom_2li','bloom_3lu',
  ];

  defShowObjects = [

    'bloom_tekli',

  ];


  availableAnimations: AnimationDefinition[] = [];


  async created() {
    this.product = Store.getProductById('bloom1');
    this.product.partsPalettes = _.orderBy(this.product.partsPalettes, ['order'], ['asc']);
    this.availableAnimations = this.product.animations as any;
    this.availableAnimationsChanged();

    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });


    if (Store.state.selection) {
      Store.state.selection.parts.forEach((element) => {
        this.colorChanged(element.color, element.palette, element.id);
      });


    } else {
      await this.applyDefaultSelection();
    }

  }


  availableAnimationsChanged() {

    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }



  mounted() {
    // this.configuratorService = Store.state.configuratorService;

  }

  async applyDefaultSelection() {
    const selection = new VirgoSelection();
    selection.parts = [];


    this.product.defaults.parts.forEach((element) => {
      this.colorChanged(element.color, element.palette, element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.palette = element.palette;
      part.name = element.name;
      selection.parts.push(part);
    });

    Store.state.selection = selection;
   // this.kizakliAnimations(false);
  }




  async colorChanged(color: any, palette: any, part: any) {

    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
  }

}

export class VirgoSelection {
  parts: PartSelection[];

}
export class PartSelection {
  id: string;
  palette: string;
  color: string;
  name: string;
}





// WEBPACK FOOTER //
// ./src/components/families/bloom/Bloom1.ts